module.exports = "/_next/static/pages/administer/1fa8b06bb506b32733e1824392565ad5.png";